import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_BACKEND_API_URL;

/**
 * Maps login API body.value to the shape used across the app.
 * Supports both legacy ({ userDetails, accessToken }) and call-center ({ token, role, ... }) payloads.
 */
export const mapLoginResponseToUser = (value) => {
  if (!value) return null;

  if (value.userDetails) {
    const legacy = value.userDetails;
    const accessToken = value.accessToken || value.token;
    return {
      ...legacy,
      accessToken,
    };
  }

  const accessToken = value.token || value.accessToken;
  const role = value.role || "";
  const userType = value.userType || (role ? String(role).toLowerCase() : "");

  return {
    userId: value.userId,
    email: value.email,
    name: value.name,
    role,
    userType,
    accessToken,
    profilePic: value.profilePic ?? null,
    userVisibility: value.userVisibility,
    firstTimeLogin: value.firstTimeLogin ?? "false",
    organization: value.organization,
    departmentList: value.departmentList,
    projectList: value.projectList,
    canAddEditUser: value.canAddEditUser ?? userType === "super_admin",
    canCreateDashboard: value.canCreateDashboard,
    canAccessCustomerSupport: value.canAccessCustomerSupport,
    allowedPages: value.allowedPages,
  };
};
  // const response = await axios.post(`${BASE_URL}api/auth/login`, values, {

export const loginUser = async (values) => {
  const response = await axios.post(`${BASE_URL}api/auth/login`, values, {
    headers: {
      "X-App-Type": "WEB",
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const getUserPermissions = async (accessToken) => {
  const response = await axios.get(`${BASE_URL}api/v1/user/permissions`, {
    headers: {
      "X-App-Type": "WEB",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};
export const storeFcmToken = async (token, accessToken) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/notification/store-fcm-token`,
    { token },
    {
      headers: {
        "X-App-Type": "WEB",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/forgot-password`,
    {},
    {
      params: { email },
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const checkOtp = async (otp, email) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/check-otp`,
    { otp, email },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const resetPassword = async (email, password) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/new-password`,
    { email, password },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
